import { Document, SectionType, Paragraph, TextRun, AlignmentType, UnderlineType, PageOrientation } from "docx";
import { InformeWordService } from "../informe-word-api";

export function informeWord2025(constantes, anio, anioAnterior, instalacion, organizacion, datos) {
  const informe = new InformeWordService(constantes);

  const doc = new Document({
        sections: [
            {
                properties: {},
                children: [
                    informe.portada2025(anio, instalacion, datos.orgaLogo)
                ],
            },
            //*****************************Fin Seccion para la portada************************************************ */
            {
                properties: {
                    type: SectionType.CONTINUOUS
                },
                children: [
                    new Paragraph({
                        children: [
                            new TextRun( { text: "Recomendaciones para el adecuado llenado de este documento:", font: 'Arial', size: 28, bold: true } )
                        ],
                        spacing: { after: 200 },// espacio después en twips (300 ≈ 0.21 inch ≈ 0.54 cm)
                    }),
                    new Paragraph({
                        alignment: AlignmentType.JUSTIFIED,
                        children: [
                            new TextRun( { text: "Previo a completarlo, se debe realizar lectura completa del Manual de Procedimiento de la Categoría Cambio Climático, versión XII 2024.", font: 'Arial', size: 24 } )
                        ],
                        bullet: { level: 0 },
                        spacing: { after: 150 }
                    }),
                    new Paragraph({
                        alignment: AlignmentType.JUSTIFIED,
                        children: [
                            new TextRun( { text: "Las imágenes que coloquen como evidencias deben ser legibles y claras, que permitan su lectura y visualizar la información que nos quieren transmitir, de lo contrario no se tomaran en cuenta para sumarle los puntos. Revisar cuando pasan de tipo Word a PDF.", font: 'Arial', size: 24 } )
                        ],
                        bullet: { level: 0 },
                        spacing: { after: 150 }
                    }),
                    new Paragraph({
                        alignment: AlignmentType.JUSTIFIED,
                        children: [
                            new TextRun( { text: "En los espacios para incluir evidencias, pueden ajustarlos según el tamaño de estas, para cumplir con lo solicitado en el punto anterior.", font: 'Arial', size: 24 } )
                        ],
                        bullet: { level: 0 },
                        spacing: { after: 150 }
                    }),
                    new Paragraph({
                        alignment: AlignmentType.JUSTIFIED,
                        children: [
                            new TextRun( { text: "Todas las actividades y acciones por contemplar en el Informe Final deben corresponder al año de participación (2025)", font: 'Arial', size: 24 } )
                        ],
                        bullet: { level: 0 },
                        spacing: { after: 150 }
                    }),
                    new Paragraph({
                        alignment: AlignmentType.JUSTIFIED,
                        children: [
                            new TextRun( { text: "No se aceptan anexos ni enlaces para verificar la información que quieren mostrar. En cada parámetro y subparámetro específico del informe, deben evidenciar la información solicitada.", font: 'Arial', size: 24 } )
                        ],
                        bullet: { level: 0 },
                        spacing: { after: 150 }
                    }),
                    new Paragraph({
                        alignment: AlignmentType.JUSTIFIED,
                        children: [
                            new TextRun( { text: "No deben alterar nada del esquema de informe final que se les suministra. Si consideran que no les aplica alguna información, pueden indicar que no les aplica, o que no optan por este (en caso de estrellas), o bien lo dejan en blanco, pero no lo deben borrar.", font: 'Arial', size: 24 } )
                        ],
                        bullet: { level: 0 },
                        spacing: { after: 150 }
                    }),
                    new Paragraph({
                        alignment: AlignmentType.JUSTIFIED,
                        children: [
                            new TextRun( { text: "Para la notación de las cifras de los consumos: como separador de decimales deben utilizar la coma (,) en todo el documento; y, los números con grandes cantidades de cifras se deben agrupar en conjuntos de 3, separados por espacios.", font: 'Arial', size: 24 } )
                        ],
                        bullet: { level: 0 },
                        spacing: { after: 150 }
                    }),
                    new Paragraph({
                        alignment: AlignmentType.JUSTIFIED,
                        children: [
                            new TextRun( { text: "En algunas tablas, se encuentran filas de color gris, que corresponden a ejemplos con el fin de que sirvan de guía para completar lo que se solicita.", font: 'Arial', size: 24 } )
                        ],
                        bullet: { level: 0 },
                        spacing: { after: 150 }
                    }),
                    new Paragraph({
                        alignment: AlignmentType.JUSTIFIED,
                        children: [
                            new TextRun( { text: "En los cuadros de reducción, se identifica con la letra “A” la columna en la cual se requiere los datos de consumo del año anterior y con la letra “B” los del año de participación.", font: 'Arial', size: 24 } )
                        ],
                        bullet: { level: 0 },
                        spacing: { after: 150 }
                    }),
                    new Paragraph({
                        alignment: AlignmentType.JUSTIFIED,
                        children: [
                            new TextRun( { text: "El tamaño máximo del informe final a subir en el sistema debe ser de 10 MB, sin embargo, si excede ese tamaño se debe subir entre las 5:00 pm. a 7:30 am.", font: 'Arial', size: 24 } )
                        ],
                        bullet: { level: 0 },
                        spacing: { after: 150 }
                    }),
                    new Paragraph({
                        alignment: AlignmentType.JUSTIFIED,
                        children: [
                            new TextRun( { text: "El nombre del archivo para subir y enviar el informe final debe ir de la siguiente forma: Informe final PBAE CCC año + código comité + nombre organización + nombre sede", font: 'Arial', size: 24 } )
                        ],
                        bullet: { level: 0 },
                        spacing: { after: 150 }
                    }),
                    new Paragraph({
                        alignment: AlignmentType.JUSTIFIED,
                        children: [
                            new TextRun( { text: "Para más recomendaciones, por favor consultar el apartado Aspectos relevantes por considerar en la elaboración del Informe Final, del Manual de Procedimiento Categoría Cambio Climático.", font: 'Arial', size: 24 } )
                        ],
                    }),
                ]
            },//fin seccion recomendaciones
            {
                properties: {
                    type: SectionType.NEXT_PAGE
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 200 },
                        children: [ new TextRun( { text: "Contenido", font: 'Arial', size: 32, color: '#365F91', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "Generalidades de la organización", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "Resumen Ejecutivo", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "Información requerida por parámetro", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tParámetro N°1: Cumplimiento Legal", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tParámetro N°2: Combustibles Fósiles", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tParámetro N°3: Agua", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tParámetro N°4: Tratamiento Aguas Residuales", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tParámetro N°5: Energía Eléctrica", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tParámetro N°6: Gestión de Residuos", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tParámetro N°7: Gases Refrigerantes", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tParámetro N°8: Compras Sostenibles", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tParámetro N°9: Adaptación al Cambio Climático", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tParámetro N°10: Compensación Ambiental", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "Gradación de Estrellas", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tUna estrella blanca", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tDos estrellas blancas", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tTres estrellas blancas", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tCuatro estrellas blancas", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tCinco estrellas blancas", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tSeis estrellas blancas", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tEstrella Verde", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tEstrella Plateada", font: 'Times New Roman', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "\tEstrella Anaranjada", font: 'Times New Roman', size: 24 } ) ],
                    }),
                ]
            },
            {
                properties: { 
                    type: SectionType.NEXT_PAGE
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "Generalidades de la organización", font: 'Arial', size: 32, color: '#365F91', bold: true } ) ],
                    }),
                    informe.orgGeneralidades2025(datos, instalacion),
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "Resumen Ejecutivo", font: 'Arial', size: 32, color: '#365F91', bold: true } ) ],
                    }),
                    informe.resumenEjecutivo2025(instalacion, datos),
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 250 },
                        children: [ new TextRun( { text: "Información requerida por parámetro", font: 'Arial', size: 32, color: '#365F91', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250 },
                        children: [ new TextRun( { text: "Parámetro N°1.: Cumplimiento Legal", font: 'Arial', size: 28, color: '#365F91', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "1.1 Cuestionario para autoevaluar el cumplimiento legal", font: 'Arial', size: 24, bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.JUSTIFIED,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "Cada año de participación deben presentar el “Cuestionario para autoevaluar el cumplimiento legal” en el mismo momento en que presentan el informe final del año de participación (son dos documentos independientes).", font: 'Arial', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.JUSTIFIED,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "Seguir las indicaciones para el llenado del cuestionario, que están en la pestaña “Indicaciones Generales” del Excel.", font: 'Arial', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.JUSTIFIED,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "Se debe presentar en formato PDF, completo y firmado.", font: 'Arial', size: 24 } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Parámetro N°2: Combustibles Fósiles", font: 'Arial', size: 28, color: '#365F91', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "2.1 Caso 1. Sedes que ", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "SI", font: 'Arial', size: 24, bold: true, underline: { type: UnderlineType.SINGLE } } ),
                                    new TextRun( { text: " consumen combustibles fósiles.", font: 'Arial', size: 24, bold: true } )
                        ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "2.1.1.", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "Inventario de la flota vehicular, maquinaria y/o equipos que consumen combustible fósil, que están bajo control de la sede participante.", font: 'Arial', size: 24 } ),
                        ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°1", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: "Inventario de la flota vehicular, maquinaria y/o equipo que consumen combustible fósil", font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.flotaVehicular2025(datos.flotaCasoUno),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación por ausencia de datos:', datos.justCombusInve, datos.docsJustInventarioComb, '#8db3e2')
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "2.1.2.", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "Determinación del consumo por tipo de combustible fósil.", font: 'Arial', size: 24 } ),
                        ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°2", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Consumo mensual de combustibles fósiles del año anterior al de participación (${anioAnterior})`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.tablaConsumo2025('Cantidad en litros (l) de combustibles fósiles consumidos', 'Tipo de Combustible/Mes', '#fabf8f', datos.consumoCombAnterior),
                    new Paragraph({ children: [
                        new TextRun( { text: "Símbolos a utilizar:", font: 'Arial', size: 18, underline: UnderlineType.SINGLE, italics: true } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: ",", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Separador de decimales", font: 'Arial', size: 18 } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: "NSU", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": No se utiliza", font: 'Arial', size: 18 } ),
                    ] }),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación por ausencia de datos o consumo igual a cero:', datos.justCombConsAnte, null, '#fabf8f'),
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°3", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Consumo mensual de combustibles fósiles del año de participación (${anio})`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.tablaConsumo2025('Cantidad en litros (l) de combustibles fósiles consumidos', 'Tipo de Combustible/Mes', '#8db3e2', datos.consumoCombutibles),
                    new Paragraph({ children: [
                        new TextRun( { text: "Símbolos a utilizar:", font: 'Arial', size: 18, underline: UnderlineType.SINGLE, italics: true } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: ",", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Separador de decimales", font: 'Arial', size: 18 } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: "NSU", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": No se utiliza", font: 'Arial', size: 18 } ),
                    ] }),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación por ausencia de datos o consumo igual a cero (en uno o todos los tipos de combustible):', datos.justCombusCons, datos.docsJustConsumoComb, '#8db3e2'),
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "2.1.3 Reducción del consumo de combustible fósil mayor a un 1%, respecto al año anterior.", font: 'Arial', size: 24, bold: true } ) ],
                    }),
                    informe.detReduccion2025(anioAnterior, anio, constantes.indicadorCombustibles, datos.reduccionTrimestral),
                    informe.tablaReduccionPorTipo2025(constantes.indicadorCombustibles, datos.reducCombust, anioAnterior, anio, datos.reduccionTrimestral),
                    new Paragraph({ children: [
                        new TextRun( { text: "Siglas, abreviaturas y símbolos a utilizar:", font: 'Arial', size: 18, underline: UnderlineType.SINGLE, italics: true } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: ",", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Separador de decimales", font: 'Arial', size: 18 } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: "-", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Resta", font: 'Arial', size: 18 } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: "*", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Multiplicación", font: 'Arial', size: 18 } ),
                    ] }),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación en caso de: 1) aumento del consumo total o algún tipo de uso, 2) ausencia de datos o 3) datos igual a cero:', datos.justCombus, datos.docsJustReduccionComb, '#92cddc', datos.reduccionTrimestral), 
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                     new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "2.1.4.", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "Educación ambiental ", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "(Dos actividades)", font: 'Arial', size: 24 } ),
                        ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°5", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Educación Ambiental`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                ],
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.educacionAmbiental2025(datos.educaCombustibles)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                     new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "2.1.5.", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "Acciones de registro, reducción y control ", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "(Una actividad)", font: 'Arial', size: 24 } ),
                        ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°6", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Acción de registro, reducción y control`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                ],
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.accionReduccion2025(datos.accionReducComb)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250 },
                        children: [ new TextRun( { text: "Parámetro N°3: Agua", font: 'Arial', size: 28, color: '#365F91', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "3.1 Verificación de la calidad del agua para consumo humano", font: 'Arial', size: 24, bold: true } ) ],
                    }),
                    informe.tituloConEvidencias( 'Servicio por ente operador: Documento que permita comprobar el servicio', datos.potabilidadAgua, '#8db3e2', null),
                    informe.tituloConEvidencias( 'Fuentes propias: Análisis de calidad agua potable que considere mínimo el N1, realizado por un laboratorio acreditado por el ECA. ', datos.potabilidadAguaPropia, '#8db3e2', null),
                    informe.justificacionConEvidencias('Justificación en caso de ausencia de datos', datos.justPotabilidadAgua, datos.docsJustCalidadAgua, '#8db3e2'),
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "3.2 Determinación del consumo de agua para uso humano y el proceso productivo.", font: 'Arial', size: 24, bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°8", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Consumo mensual de agua del año anterior al de participación (${anioAnterior})`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.tablaConsumoAgua2025('Consumo mensual de agua en metros cúbicos (m3)', 'Medidor', '#fabf8f', datos.consumoAguaAnterior),
                    new Paragraph({ children: [
                        new TextRun( { text: "Símbolos a utilizar:", font: 'Arial', size: 18, underline: UnderlineType.SINGLE, italics: true } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: ",", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Separador de decimales", font: 'Arial', size: 18 } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: "NSU", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": No se utiliza", font: 'Arial', size: 18 } ),
                    ] }),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación por ausencia de datos o consumo igual a cero:', datos.justAguaConsAnte, null, '#fabf8f'),
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°8", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Consumo mensual de agua del año anterior al de participación (${anio})`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.tablaConsumoAgua2025('Consumo mensual de agua en metros cúbicos (m3)', 'Medidor', '#8db3e2', datos.consumoAguaActual),
                    new Paragraph({ children: [
                        new TextRun( { text: "Símbolos a utilizar:", font: 'Arial', size: 18, underline: UnderlineType.SINGLE, italics: true } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: ",", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Separador de decimales", font: 'Arial', size: 18 } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: "NSU", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": No se utiliza", font: 'Arial', size: 18 } ),
                    ] }),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación por ausencia de datos o consumo igual a cero:', datos.justAguaConsAnte, datos.docsJustConsumoAgua, '#8db3e2'),
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "3.3 Reducción en el consumo del agua para uso humano y el proceso productivo mayor a un 1%.", font: 'Arial', size: 24, bold: true } ) ],
                    }),
                    informe.detReduccion2025(anioAnterior, anio, constantes.indicadorAgua, datos.aguaTrimestral),
                    informe.tablaReduccionPorTipo2025(constantes.indicadorAgua, datos.reduccionAgua, anioAnterior, anio, datos.aguaTrimestral),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación en caso de: 1) aumento del consumo total o algún tipo de uso, 2) ausencia de datos o 3) datos igual a cero:', datos.justAgua, datos.docsJustReducciongua, '#8db3e2', datos.aguaTrimestral),
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                     new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "3.4.", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "Educación ambiental ", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "(Dos actividades)", font: 'Arial', size: 24 } ),
                        ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°11", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Educación Ambiental`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                ],
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.educacionAmbiental2025(datos.educacionAgua)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                     new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "3.5.", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "Acciones de registro, reducción y control ", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "(Una actividad)", font: 'Arial', size: 24 } ),
                        ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°12", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Acción de registro, reducción y control`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                ],
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.accionReduccion2025(datos.accionReducAgua)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250 },
                        children: [ new TextRun( { text: "Parámetro N°4: Tratamiento Aguas Residuales", font: 'Arial', size: 28, color: '#365F91', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "4.1. Identificación del Sistema de Tratamiento de Aguas Residuales (STAR) utilizado en la Sede", font: 'Arial', size: 24, bold: true } ) ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "Completar según el STAR que le aplique a la sede. En los casos que la sede cuente con dos STAR, solamente debe completar la información de uno de ellos.", font: 'Arial', size: 24 } ) ],
                    }),
                    informe.detalleTipoStar(datos.tipoSistemaTrat),
                ]
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS
                },
                children: informe.identificarStar2025(datos.tipoSistemaTrat)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                     new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "4.2.", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "Educación ambiental ", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "(Dos actividades)", font: 'Arial', size: 24 } ),
                        ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°13", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Educación Ambiental`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                ],
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.educacionAmbiental2025(datos.educcacionAguasRes)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                     new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "4.3.", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "Acciones de registro, reducción y control ", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "(Una actividad)", font: 'Arial', size: 24 } ),
                        ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°14", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Acción de registro, reducción y control`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                ],
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.accionReduccion2025(datos.accionReducAguResid)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250 },
                        children: [ new TextRun( { text: "Parámetro N°5: Energía Eléctrica", font: 'Arial', size: 28, color: '#365F91', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "5.1 Determinación del consumo de energía eléctrica", font: 'Arial', size: 24, bold: true } ) ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°15", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Consumo mensual de electricidad del año anterior al de participación (${anioAnterior})`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.tablaConsumo2025('Consumo mensual de electricidad en Kilowatt hora (kW/h)', 'Medidor/Mes', '#fabf8f', datos.consumoEnergiaAnterior),
                    new Paragraph({ children: [
                        new TextRun( { text: "Símbolos a utilizar:", font: 'Arial', size: 18, underline: UnderlineType.SINGLE, italics: true } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: ",", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Separador de decimales", font: 'Arial', size: 18 } )
                    ] }),
                    informe.justificacionConEvidencias('Justificación por ausencia de datos o consumo igual a cero:', datos.justEnerConsAnte, null, '#fabf8f'),
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°16", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Consumo mensual de electricidad del año de participación (${anio})`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.tablaConsumo2025('Consumo mensual de electricidad en Kilowatt hora (kW/h)', 'Medidor/Mes', '#8db3e2', datos.consumoEnergiaActual),
                    new Paragraph({ children: [
                        new TextRun( { text: "Símbolos a utilizar:", font: 'Arial', size: 18, underline: UnderlineType.SINGLE, italics: true } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: ",", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Separador de decimales", font: 'Arial', size: 18 } )
                    ] }),
                    informe.justificacionConEvidencias('Justificación por ausencia de datos o consumo igual a cero:', datos.justEnerCons, datos.docsJustConsumoEnergia, '#8db3e2'),
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "5.2. Reducción en el consumo de energía eléctrica mayor al 1%, respecto al año anterior.", font: 'Arial', size: 24, bold: true } ) ],
                    }),
                    informe.detReduccion2025(anioAnterior, anio, constantes.indicadorEnergia, datos.energiaReducTrimestral),
                    informe.tablaReduccionPorTipo2025(constantes.indicadorEnergia, datos.reduccionEnergia, anioAnterior, anio, datos.energiaReducTrimestral),
                    new Paragraph({ children: [
                        new TextRun( { text: "Siglas, abreviaturas y símbolos a utilizar:", font: 'Arial', size: 18, underline: UnderlineType.SINGLE, italics: true } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: ",", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Separador de decimales", font: 'Arial', size: 18 } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: "-", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Resta", font: 'Arial', size: 18 } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: "*", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Multiplicación", font: 'Arial', size: 18 } ),
                    ] }),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación en caso de: 1) aumento del consumo total o algún tipo de uso, 2) ausencia de datos o 3) datos igual a cero:', datos.justEnergia, datos.docsJustReduccionEnergia, '#92cddc', datos.energiaReducTrimestral), 
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                     new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "5.3.", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "Educación ambiental ", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "(Dos actividades)", font: 'Arial', size: 24 } ),
                        ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°18", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Educación Ambiental`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                ],
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.educacionAmbiental2025(datos.educacionEnergia)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                     new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "5.4.", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "Acciones de registro, reducción y control ", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "(Una actividad)", font: 'Arial', size: 24 } ),
                        ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°19", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Acción de registro, reducción y control`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                ],
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.accionReduccion2025(datos.accionReduccionEnergia)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250 },
                        children: [ new TextRun( { text: "Parámetro N°6: Gestión de Residuos", font: 'Arial', size: 28, color: '#365F91', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "6.1 Determinación del consumo de papel", font: 'Arial', size: 24, bold: true } ) ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°20", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Consumo mensual de papel de oficina del año anterior al de participación (${anioAnterior})`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.tablaConsumo2025('Consumo mensual de papel (Resmas)', 'Cantidad/Mes', '#fabf8f', datos.consumoResiduosAnterior),
                    new Paragraph({ children: [
                        new TextRun( { text: "Nota: Una resma equivale a 500 hojas", font: 'Arial', size: 18 } )
                    ] }),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación por ausencia de datos o consumo igual a cero:', datos.justResiduConsAnte, null, '#fabf8f'),
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°21", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Consumo mensual de papel de oficina del año de participación (${anio})`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.tablaConsumo2025('Consumo mensual de papel (Resmas)', 'Cantidad/Mes', '#8db3e2', datos.consumoResiduosActual),
                    new Paragraph({ children: [
                        new TextRun( { text: "Nota: Una resma equivale a 500 hojas", font: 'Arial', size: 18 } ),
                    ] }),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación por ausencia de datos o consumo igual a cero:', datos.justConsPapel, datos.docsJustConsumoPapel, '#8db3e2'),
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "6.2. Reducción del uso de papel en al menos un 1%, respecto al año anterior.", font: 'Arial', size: 24, bold: true } ) ],
                    }),
                    informe.detReduccion2025(anioAnterior, anio, constantes.indicadorResiduos, datos.papelReducTrimestral),
                    informe.tablaReduccionPorTipo2025(constantes.indicadorResiduos, datos.reduccionPapel, anioAnterior, anio, datos.papelReducTrimestral),
                    new Paragraph({ children: [
                        new TextRun( { text: "Siglas, abreviaturas y símbolos a utilizar:", font: 'Arial', size: 18, underline: UnderlineType.SINGLE, italics: true } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: ",", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Separador de decimales", font: 'Arial', size: 18 } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: "-", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Resta", font: 'Arial', size: 18 } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: "*", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Multiplicación", font: 'Arial', size: 18 } ),
                    ] }),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación en caso de: 1) aumento del consumo total o algún tipo de uso, 2) ausencia de datos o 3) datos igual a cero:', datos.justResPapel, datos.docsJustReduccionPapel, '#92cddc', datos.papelReducTrimestral), 
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "6.3 Medición y comparación de la generación de Residuos Sólidos Valorizables", font: 'Arial', size: 24, bold: true } ) ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°23", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Medición de la generación de residuos sólidos valorizables del año anterior de participación (${anioAnterior})`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.tablaConsumo2025('Generación mensual de residuos en kilogramos (kg)', 'Tipo', '#fabf8f', datos.consumoValoAnterior),
                    new Paragraph({ children: [
                        new TextRun( { text: "Nota:", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: "A excepción del tipo de residuo valorizable Chatarra y metales, esta clasificación de residuos valorizables responde a la Estrategia Nacional de Separación, Recuperación y Valorización de Residuos.", font: 'Arial', size: 18 } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: "Símbolos a utilizar:", font: 'Arial', size: 18, underline: UnderlineType.SINGLE, italics: true } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: ",", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Separador de decimales", font: 'Arial', size: 18 } )
                    ] }),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación por ausencia de datos o consumo igual a cero:', datos.justConsValoAnte, null, '#fabf8f'),
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°24", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Medición de la generación de residuos sólidos valorizables del año de participación (${anioAnterior})`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.tablaConsumo2025('Generación mensual de residuos en kilogramos (kg)', 'Tipo', '#8db3e2', datos.consumoValoActual),
                    new Paragraph({ children: [
                        new TextRun( { text: "Nota:", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: "A excepción del tipo de residuo valorizable Chatarra y metales, esta clasificación de residuos valorizables responde a la Estrategia Nacional de Separación, Recuperación y Valorización de Residuos.", font: 'Arial', size: 18 } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: "Símbolos a utilizar:", font: 'Arial', size: 18, underline: UnderlineType.SINGLE, italics: true } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: ",", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Separador de decimales", font: 'Arial', size: 18 } )
                    ] }),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación por ausencia de datos o consumo igual a cero:', datos.justConsValo, datos.docsJustConsumoValor, '#8db3e2'),
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "6.4. Reducción de residuos sólidos valorizables en al menos un 1%, respecto al año anterior.", font: 'Arial', size: 24, bold: true } ) ],
                    }),
                    informe.detReduccion2025(anioAnterior, anio, constantes.indicadorResiduosValorizables, datos.resValTrimestral),
                    informe.tablaReduccionPorTipo2025(constantes.indicadorResiduosValorizables, datos.resValorizales, anioAnterior, anio, datos.resValTrimestral),
                    new Paragraph({ children: [
                        new TextRun( { text: "Siglas, abreviaturas y símbolos a utilizar:", font: 'Arial', size: 18, underline: UnderlineType.SINGLE, italics: true } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: ",", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Separador de decimales", font: 'Arial', size: 18 } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: "-", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Resta", font: 'Arial', size: 18 } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: "*", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Multiplicación", font: 'Arial', size: 18 } ),
                    ] }),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.disposicionResiduos(datos.resValorizales),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación en caso de: 1) aumento del consumo total o algún tipo de uso, 2) ausencia de datos o 3) datos igual a cero:', datos.justResiduos, null, '#92cddc', datos.resValTrimestral), 
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "6.5. Medición y comparación de la generación de residuos sólidos no valorizables", font: 'Arial', size: 24, bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°26", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Medición de la generación de residuos sólidos no valorizables del año anterior de participación (${anioAnterior})`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.tablaConsumo2025('Generación mensual de residuos en kilogramos (kg)', 'Tipo/Mes', '#fac090', datos.consumoNoValoAnterior),
                    new Paragraph({ children: [
                        new TextRun( { text: "Símbolos a utilizar:", font: 'Arial', size: 18, underline: UnderlineType.SINGLE, italics: true } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: ",", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Separador de decimales", font: 'Arial', size: 18 } )
                    ] }),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación por ausencia de datos o consumo igual a cero:', datos.justConsNoValoAnte, null, '#fac090'),
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°27", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Medición de la generación de residuos sólidos no valorizables del año de participación (${anio})`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.tablaConsumo2025('Generación mensual de residuos en kilogramos (kg)', 'Tipo/Mes', '#8db3e2', datos.consumoNoValolActual),
                    new Paragraph({ children: [
                        new TextRun( { text: "Símbolos a utilizar:", font: 'Arial', size: 18, underline: UnderlineType.SINGLE, italics: true } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: ",", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Separador de decimales", font: 'Arial', size: 18 } )
                    ] }),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación por ausencia de datos o consumo igual a cero:', datos.justConsNoValo, datos.docsJustConsumoNoValor, '#8db3e2'),
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "6.6. Reducción de residuos no valorizables en al menos un 1%, respecto al año anterior.", font: 'Arial', size: 24, bold: true } ) ],
                    }),
                    informe.detReduccion2025(anioAnterior, anio, constantes.indicadorResiduosNoValorizables, datos.resValNoTrimestral),
                    informe.tablaReduccionPorTipo2025(constantes.indicadorResiduosNoValorizables, datos.resNoValorizales, anioAnterior, anio, datos.resValNoTrimestral),
                    new Paragraph({ children: [
                        new TextRun( { text: "Siglas, abreviaturas y símbolos a utilizar:", font: 'Arial', size: 18, underline: UnderlineType.SINGLE, italics: true } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: ",", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Separador de decimales", font: 'Arial', size: 18 } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: "-", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Resta", font: 'Arial', size: 18 } ),
                        new TextRun( { break: 1 } ), 
                        new TextRun( { text: "*", font: 'Arial', size: 18, bold: true } ),
                        new TextRun( { text: ": Multiplicación", font: 'Arial', size: 18 } ),
                    ] }),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación en caso de: 1) aumento del consumo total o algún tipo de uso, 2) ausencia de datos o 3) datos igual a cero:', datos.justResiduosNo, null, '#92cddc', datos.reduccTrimNoVal), 
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "6.7. Trazabilidad de la gestión de residuos de manejo especial", font: 'Arial', size: 24, bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°29", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Descripción de la trazabilidad de la gestión de residuos de manejo especial`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.trazabilidadResEspeciales(datos.residuosEspeciales),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.tablaEvidenciasResEspec(datos.residuosEspecialesDTO),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación en caso de ausencia de datos o espacios en blanco en este apartado. Si indican que no generan residuos de manejo especial, brindar explicación detallada del por qué consideran que no lo generan', datos.justifResidEspeciales, null, '#92cddc' ), 
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 150 },
                        children: [ new TextRun( { text: "6.8. Trazabilidad de la gestión de residuos peligrosos", font: 'Arial', size: 24, bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°30", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Descripción de la trazabilidad de la gestión de residuos peligrosos`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.trazabilidadResEspeciales(datos.residuosPeligrosos),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.tablaEvidenciasResEspec(datos.residuosPeligrososDTO),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    informe.justificacionConEvidencias('Justificación en caso de ausencia de datos o espacios en blanco en este apartado. Si indican que no generan residuos peligrosos, brindar explicación detallada del por qué consideran que no lo generan', datos.justifResidPeligrosos, null, '#92cddc' ), 
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                     new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "6.9.", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "Educación ambiental ", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "(Dos actividades)", font: 'Arial', size: 24 } ),
                        ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°31", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Educación Ambiental`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                ],
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.educacionAmbiental2025(datos.educacionResiduos)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                     new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "6.10.", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "Acciones de registro, reducción y control ", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "(Una actividad)", font: 'Arial', size: 24 } ),
                        ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°32", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Acción de registro, reducción y control`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                ],
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.accionReduccion2025(datos.accionReduccionResiduos)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250 },
                        children: [ new TextRun( { text: "Parámetro N°7: Gases Refrigerantes", font: 'Arial', size: 28, color: '#365F91', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "7.1 Inventario de equipos que consumen gases refrigerantes", font: 'Arial', size: 24, bold: true } ) ]
                    }),
                    informe.inventGasesTitutlo(datos.sinEquipos),
                ]
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.inventGases(datos.inventarioContAtmos, datos.sinEquipos, datos.educacionAmbientalCaso2, datos.accionReduccionCaso2),
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                     new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "7.2.", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "Educación ambiental ", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "(Una actividad)", font: 'Arial', size: 24 } ),
                        ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°34", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Educación Ambiental`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                ],
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.educacionAmbiental2025(datos.educaGases)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                     new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "7.3.", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "Acciones de registro, reducción y control ", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "(Una actividad)", font: 'Arial', size: 24 } ),
                        ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°35", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Acción de registro, reducción y control`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                ],
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.accionReduccion2025(datos.accionReduccionContAtmos)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250 },
                        children: [ new TextRun( { text: "Parámetro N°8: Compras Sostenibles", font: 'Arial', size: 28, color: '#365F91', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "8.1 Criterios de compras sostenibles en ejecución, que permita a la organización un consumo ambiental y socialmente responsable", font: 'Arial', size: 24, bold: true } ) ]
                    }),
                    informe.tituloConEvidencias('Portada y firma de la política y/o programa establecido para compras sostenibles:', datos.programaCompSostEvid, '#8db3e2', null),
                    informe.justificacionConEvidencias('Describir los criterios sostenibles que utiliza la organización en la compra de bienes y servicios (en caso de no contar con política o programa para compras sostenibles):', datos.descripProg, null, '#8db3e2', null),
                ]
            },            
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250 },
                        children: [ new TextRun( { text: "Parámetro N°8: Compras Sostenibles", font: 'Arial', size: 28, color: '#365F91', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "8.2 Productos adquiridos aplicando los criterios de compras sostenibles establecidos en la organización", font: 'Arial', size: 24, bold: true } ) ]
                    }),
                    informe.productoSostTitulo(datos.sinProductos)
                ]
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.inventProdSostenibles(datos.sinProductos, datos.productosSost, datos.educacionCompras, datos.reduccionCompras)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250 },
                        children: [ new TextRun( { text: "Parámetro N°9: Adaptación al Cambio Climático", font: 'Arial', size: 28, color: '#365F91', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "9.1 Identificación de las amenazas climáticas a las que está expuesta la sede y sus partes interesadas", font: 'Arial', size: 24, bold: true } ) ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°37", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Identificación de las amenazas climáticas`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.amenazaClimatica(datos.amenazas),
                    new Paragraph({ text: "", spacing: { after: 100 } }),//espacio en blanco
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "Escala de valoración de la exposición", font: 'Arial', size: 24, bold: true } ) ]
                    }),
                    informe.escalaValoracion(),
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "9.2 Identificación de los impactos para la organización y sus partes interesadas debido al cambio climático", font: 'Arial', size: 24, bold: true } ) ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°38", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Impactos del cambio climático para la organización y sus partes interesadas`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.impactosClimaticos(datos.impactos)
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "9.3 Implementación de acciones de adaptación ", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "(Dos acciones)", font: 'Arial', size: 24 } )
                         ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°39", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Acciones de adaptación implementadas o en proceso de implementación por la organización`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    })
                ]
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.accionesAdaptacion(datos.accionesAdaptacion)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                     new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "9.4.", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "Educación ambiental ", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "(Una actividad)", font: 'Arial', size: 24 } ),
                        ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°40", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Educación Ambiental`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                ],
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.educacionAmbiental2025(datos.educacionAdaptacion)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250 },
                        children: [ new TextRun( { text: "Parámetro N°10: Compensación Ambiental", font: 'Arial', size: 28, color: '#365F91', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "10.1 Actividad de compensación, con relación al impacto generado por la sede en alguno de los parámetros antes citados.", font: 'Arial', size: 24, bold: true } ) ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°41", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Actividad de compensación`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    })
                ]
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.actividadCompensacion(datos.actividadesComp, datos.actividadesCompEvid, datos.actCompDispEvid)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                     new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 300 },
                        children: [ new TextRun( { text: "10.2.", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "Educación ambiental ", font: 'Arial', size: 24, bold: true } ),
                                    new TextRun( { text: "(Dos actividades)", font: 'Arial', size: 24 } ),
                        ]
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°42", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Educación Ambiental`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                ],
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.educacionAmbiental2025(datos.educacionCompensacion)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        spacing: { after: 200 },
                        children: [ new TextRun( { text: "Gradación de Estrellas", font: 'Arial', size: 32, color: '#365F91', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 200 },
                        children: [ new TextRun( { text: "Una estrella blanca", font: 'Arial', size: 28, color: '#1f497d', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.JUSTIFIED,
                        spacing: { after: 200 },
                        children: [ 
                            new TextRun({ 
                                text: "La sede que logre un porcentaje anual del 90 al 100% de los parámetros obligatorios (apartados anteriores de este documento).", 
                                font: 'Arial', 
                                size: 24 
                            }) 
                        ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 200 },
                        children: [ new TextRun( { text: "Dos estrellas blancas", font: 'Arial', size: 28, color: '#1f497d', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°43", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Actividades o reconocimiento para optar por dos estrellas blancas`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    })
                ]
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.segundaEstrellaBlanca(datos.programasGest, datos.programasGestEvid)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 200 },
                        children: [ new TextRun( { text: "Tres estrellas blancas", font: 'Arial', size: 28, color: '#1f497d', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°44", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Actividades para incentivar y acompañar en PBAE (dentro cadena valor)`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    })
                ]
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.terceraEstrellaBlanca(datos.promoPbaeCadVal)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 200 },
                        children: [ new TextRun( { text: "Cuatro estrellas blancas", font: 'Arial', size: 28, color: '#1f497d', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°45", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Actividades para incentivar y acompañar en PBAE (no vinculadas con cadena valor)`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    })
                ]
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.cuartaEstrellaBlanca(datos.promoPbaeComu)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 200 },
                        children: [ new TextRun( { text: "Cinco estrellas blancas", font: 'Arial', size: 28, color: '#1f497d', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°46", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Inventario emisiones y remociones de GEI`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    })
                ]
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.quintaEstrellaBlanca(datos.inventarioGei)
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 200 },
                        children: [ new TextRun( { text: "Seis estrellas blancas", font: 'Arial', size: 28, color: '#1f497d', bold: true } ) ],
                    })
                ]
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.sextaEstrellaBlanca(datos.certCarbNeutDto, 1)//opcion 1
            },
            {
                properties: {
                    type: SectionType.CONTINUOUS,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: informe.sextaEstrellaBlanca(datos.certCarbNeutDto, 2)//opcion 2
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.LANDSCAPE
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 200 },
                        children: [ new TextRun( { text: "Estrella Verde", font: 'Arial', size: 28, color: '#1f497d', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°48", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Estrella Verde: Hogares Sostenibles`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.estrellaVerdeTable(datos.notaHogares),
                    
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                    informe.estrellaVerdeEvidencias(datos.hogaresSostEvidDto)
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 200 },
                        children: [ new TextRun( { text: "Estrella Plateada", font: 'Arial', size: 28, color: '#1f497d', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 250, before:100 },
                        children: [ new TextRun( { text: "Cuadro N°49", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Datos para optar por estrella plateada`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.estrellaPlateadaTable(datos.correoEcocolones, datos.ecolonesCasoUno, datos.ecolonesCasoDos, datos.ecolonesCasoTres),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        children: [ new TextRun( { text: "Recordar que para optar por esta estrella:", font: 'Arial', size: 20, italics: true } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `1. La Sede debe tener cuenta en Ecoins`, font: 'Arial', size: 20, italics: true } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `2.Los datos deben ser incorporados en el SIBAE`, font: 'Arial', size: 20, italics: true } )
                         ],
                    }),
                    informe.espacioEnBlanco(),
                    informe.tituloConEvidencias('Evidencias (constancias, certificados, fotografías u otros) Apertura centros de acopio permanentes',datos.ecolonesCasoUno, '#8db3e2'),
                    informe.tituloConEvidencias('Evidencias (constancias, certificados, fotografías u otros) Campañas de recuperación de residuos valorizables (centros de acopio esporádicos)',datos.ecolonesCasoDos, '#8db3e2'),
                    informe.tituloConEvidencias('Evidencias (constancias, certificados, fotografías u otros) Entrega de residuos a centros de acopio, gestores autorizados o municipalidad',datos.ecolonesCasoTres, '#8db3e2'),
                ]
            },
            {
                properties: {
                    type: SectionType.NEXT_PAGE,
                    page: {
                        size: {
                            orientation: PageOrientation.PORTRAIT
                        }
                    }
                },
                children: [
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        spacing: { after: 200 },
                        children: [ new TextRun( { text: "Estrella Anaranjada", font: 'Arial', size: 28, color: '#1f497d', bold: true } ) ],
                    }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        children: [ new TextRun( { text: "Cuadro N°50", font: 'Arial', size: 28, color: '#365F91' } ),
                                    new TextRun({ break: 1 }), 
                                    new TextRun( { text: `Interés para optar por estrella anaranjada`, font: 'Arial', size: 28, color: '#365F91' } )
                         ],
                    }),
                    informe.estrellaNaranjaTable(datos.actividadesNaranja),
                    new Paragraph({
                        alignment: AlignmentType.JUSTIFIED,
                        children: [ 
                            new TextRun({ 
                                text: "No envíe las acciones realizadas al equipo técnico de la categoría Cambio Climático. Es el equipo técnico de la categoría Bienestar Animal, por la especialidad del tema, quien comunica los resultados al equipo técnico CCC de las Sedes que obtienen esta estrella. Por lo tanto, este cuadro es informativo para la CCC, pero no para la designación de la estrella anaranjada.", 
                                font: 'Arial', 
                                size: 20, 
                                italics: true 
                            }),
                        ],
                    }),
                ]
            },
        ],
    });

    return doc;
}